module.exports = __webpack_public_path__ + "img/previous-icon.1007d977.svg";